/* eslint-disable no-param-reassign, @typescript-eslint/no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';
import { ISelectOptions } from '../../../types/Common.type';

interface ISelectField {
  loading: boolean;
  data: ISelectOptions[];
}

const selectInitialData = {
  loading: false,
  data: [],
};

export interface IBeachSwapState {
  counterParties: ISelectField;
  uploadToAligne: {
    loading: boolean;
    uploadStatus: 'Success' | 'Failed' | null;
  };
  isRoleAcknowledge?: boolean;
}

const initialState: IBeachSwapState = {
  counterParties: selectInitialData,
  uploadToAligne: {
    loading: false,
    uploadStatus: null,
  },
  isRoleAcknowledge: false,
};

const beachSwapSlice = createSlice({
  name: 'beachSwapNoms',
  initialState,
  reducers: {
    clearUploadResponse: (state) => {
      state.uploadToAligne.loading = false;
      state.uploadToAligne.uploadStatus = null;
    },
    toggleRoleAcknowledge: (state, action) => {
      state.isRoleAcknowledge = action.payload;
    },
  },
});

export const BeachSwapActions = beachSwapSlice.actions;
export default beachSwapSlice.reducer;
